import React from 'react';

const RANGES = [
  { label: 'This Month', value: 'this_month' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'Last 3 Months', value: 'last_3_months' },
  { label: 'Last 6 Months', value: 'last_6_months' },
];

export default function DateRangeFilter({ selected, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {RANGES?.map((r) => (
        <button
          key={r?.value}
          onClick={() => onChange(r?.value)}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200 ${
            selected === r?.value
              ? 'bg-[rgba(0,229,255,0.15)] border border-[rgba(0,229,255,0.4)] text-[#00E5FF]'
              : 'bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.08)] text-[#64748B] hover:text-[#94A3B8] hover:border-[rgba(255,255,255,0.15)]'
          }`}
        >
          {r?.label}
        </button>
      ))}
    </div>
  );
}
